import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

export default function PaymentStatusCard() {
  const chartRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    if (chartRef.current && typeof window.finPayStatusChart !== 'undefined') {
      window.finPayStatusChart.canvas = chartRef.current;
      window.finPayStatusChart.ctx = chartRef.current.getContext('2d');
    }
  }, []);

  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">Payment Status</h3>
        <span className="click-tag">Click segments to filter</span>
      </div>
      <div className="chart-wrap" style={{ height: '240px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <canvas id="finPayStatus" ref={chartRef} style={{ maxWidth: '200px', maxHeight: '200px' }}></canvas>
      </div>
    </Box>
  );
}
